import { motion } from "framer-motion";
import { SectionBackdrop } from "./SectionBackdrop";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { useLang } from "../i18n";

export const Faq = () => {
  const { s } = useLang();
  return (
  <section id="faq" data-testid="faq-section" className="relative py-28 md:py-36">
    <SectionBackdrop id="faq" />
    <div className="relative max-w-4xl mx-auto px-4 md:px-8">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="text-center mb-16"
      >
        <p className="text-luxury-gold text-sm tracking-[0.35em] mb-6">{s.faq_eyebrow}</p>
        <h2 data-testid="faq-title" className="font-serif font-bold text-4xl sm:text-5xl text-luxury-bone leading-[1.25]">
          {s.faq_title_a} <span className="gold-gradient-text italic">{s.faq_title_b}</span>
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {s.faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-luxury-border" data-testid={`faq-item-${i}`}>
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-start font-serif text-xl text-luxury-bone hover:text-luxury-gold hover:no-underline py-6 [&[data-state=open]]:text-luxury-gold"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-luxury-gray text-base leading-loose pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
  );
};
